import { keys } from "../utils/keys";

export const apiBaseUrl = () => {
  return typeof window === "undefined"
    ? keys.general.graphqlUrl
    : keys.general.backendGraphqlUrl;
};
